<template>
    <div class="CompanyLogo">
        <div v-if="!hideAdminLogo && user.role === 'admin'" class="logo adminLogo">
            <Logo class="white" icon/>
        </div>
        <div v-else class="logo">
            <img v-if="company.logo" :src="logoUrl">
            <Icon v-else name="truck"/>
        </div>

        <span v-if="nameDisplay !== 'hidden'">{{ displayName }}</span>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Logo from '@/components/Logo';
import { getApiImgPath } from '@/utils/formatting';

export default {
    name: 'CompanyLogo',

    components: { Logo },

    props: {
        hideName: { type: Boolean, default: false },
        hideAdminLogo: { type: Boolean, default: false },
        nameDisplay: {
            default: 'hidden',
            validator(value) {
                return ['hidden', 'company', 'user'].includes(value);
            },
        },
    },

    computed: {
        ...mapState('auth', ['user']),
        ...mapGetters('auth', ['company']),

        displayName() {
            if (this.nameDisplay === 'user') {
                return `${this.user.firstName} ${this.user.lastName}`;
            }

            return this.company.name;
        },

        logoUrl() {
            return getApiImgPath(this.company.logo);
        },
    },
}
</script>

<style lang="scss" scoped>
@import 'globals.scss';

.CompanyLogo {
    display: flex;
    align-items: center;

    .logo {
        @include aspect-ratio(1,1);
        width: 40px;
        margin-right: 10px;
        background-color: $bg-color-4;
        border-radius: 50%;
        overflow: hidden;

        img {
            @include overlay();
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .Icon, .Logo {
            @include absolute-center();
            color: $text-color-muted;
            width: 50%;
            height: auto;
        }
    }

    .adminLogo {
        background-color: $brand-primary;
    }
}
</style>
